"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
var columnsFactory = function (_a) {
    var _b = _a.addPassFail, addPassFail = _b === void 0 ? false : _b;
    return __spreadArrays([
        index_1.AnalyteColumn,
        index_1.LODColumnFactory({ precision: 3 }),
        index_1.LOQColumnFactory({ precision: 3 }),
        index_1.ActionLimitsColumnFactory(),
        index_1.DefaultResultsColumnFactory({ precision: 3 })
    ], (addPassFail ? [index_1.PassFailColumn] : []));
};
exports.default = columnsFactory;
//# sourceMappingURL=columns.js.map